import { FC, useCallback } from 'react';
import { Box, Typography } from '@altermaind/web/ui';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';

type Props = {
  setActiveChip: (chip: string) => void;
  activeChip: string;
  data: string[];
};

export const Chips: FC<Props> = ({ setActiveChip, activeChip, data }) => {
  const { genericResponsiveValue } = useResponsiveStyle();

  const handleChipClick = useCallback(
    (chip: string) => {
      setActiveChip(chip);
    },
    [setActiveChip],
  );

  return (
    <>
      {data.map((chip: string) => {
        return (
          <Box
            style={{ cursor: 'pointer' }}
            onClick={() => handleChipClick(chip)}
            backgroundColor={activeChip === chip ? 'primary' : 'grey/dark/background'}
            borderRadius='l'
            px='xs'
            py='xxxs'
            key={chip}
            mr='xxs'
            textAlign={genericResponsiveValue({
              breakPoints: { desktop: 'left' },
              defaultValue: 'center',
            })}
            alignItems={genericResponsiveValue({
              breakPoints: { desktop: 'center' },
              defaultValue: 'center',
            })}
            display='flex'
            flex='0 0 auto'
          >
            <Typography variant='p2/light'>{chip}</Typography>
          </Box>
        );
      })}
    </>
  );
};
